import { css } from 'styled-components';
import styled from 'styled-components';
import { Box } from '@bechtel/gds';
import { desktopScreenListWidth, listWidth, smallScreenListWidth } from './list/styled';
import { RodRequestStatusCode } from '@bechtel/types';

interface RodRequestStatusProps {
  status?: RodRequestStatusCode;
}

export const getRodRequestStatusColor = (props: RodRequestStatusProps) => {
  switch (props.status) {
    case RodRequestStatusCode.REQUESTED:
      return css`
        background-color: ${({ theme }) => theme.colors.grey[500]};
      `;
    case RodRequestStatusCode.PARTIAL_ISSUED:
      return css`
        ${({ theme }) => css`
          background: repeating-linear-gradient(
            135deg,
            ${theme.colors.blue[400]},
            ${theme.colors.blue[400]} ${theme.spacings[150]},
            ${theme.colors.grey[1000]} ${theme.spacings[100]},
            ${theme.colors.grey[1000]} ${theme.spacings[200]}
          );
        `}
      `;
    case RodRequestStatusCode.ISSUED:
      return css`
        background-color: ${({ theme }) => theme.colors.blue[400]};
      `;
    case RodRequestStatusCode.CLOSED:
      return css`
        background-color: ${({ theme }) => theme.colors.green[500]};
      `;
    case RodRequestStatusCode.EXPIRED:
      return css`
        ${({ theme }) => css`
          background: repeating-linear-gradient(
            135deg,
            ${theme.colors.grey[200]},
            ${theme.colors.grey[200]} ${theme.spacings[150]},
            ${theme.colors.red[500]} ${theme.spacings[100]},
            ${theme.colors.red[500]} ${theme.spacings[200]}
          );
        `}
      `;
    default:
      css`
        border: 1px solid ${({ theme }) => theme.colors.grey[400]};
      `;
  }
};

export const RodRequestDetailContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  position: absolute;
  left: ${listWidth};
  overflow-y: hidden;
  height: 100vh;
  width: calc(100% - ${listWidth});
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    left: ${smallScreenListWidth};
    width: calc(100% - ${smallScreenListWidth});
  }

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    left: ${desktopScreenListWidth};
    width: calc(100% - ${desktopScreenListWidth});
  }
`;

export const StatContainerStyled = styled(Box).attrs({ pl: { sm: '500' }, justifyContent: { sm: 'space-between' } })`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    box-shadow: 1px 0 3px 0 rgba(0, 0, 0, 0.16);
    /* Z-indexneeded to show box shadow above add/issued caddy tabs */
    z-index: 1;
  `}
`;

export const IconContainerStyled = styled(Box).attrs({ px: { sm: '700' }, alignItems: { sm: 'center' } })`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
  `}
`;

export const IconBox = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
  mr: { sm: '700' },
})`
  height: 22px;
  width: 22px;
  border-radius: 100%;
  ${({ theme }) => css`
    background-color: ${theme.colors.bechtel.blue[700]};
  `}
`;

export const SubHeaderStyled = styled(Box).attrs({
  px: { sm: '500' },
  pt: { sm: '600' },
  pb: { sm: '500' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[200]};
    border-bottom: solid 1px ${theme.colors.grey[300]};
  `}
`;

export const RodRequestStatusStyled = styled.div<RodRequestStatusProps>`
  ${({ theme }) => css`
    border-radius: ${theme.radii[400]};
    margin-right: ${theme.spacings[450]};
    width: ${theme.spacings[200]};
  `}
  ${getRodRequestStatusColor}
`;
